// Stripe Configuration for Live Environment
// Note: We're using direct URL redirection instead of Stripe.js for checkout

// Product configuration matching Stripe pricing table
export const PRODUCT_CONFIG = {
  // --- Individual Plans ---
  solo: { // Renamed from 'singleCredit'
    name: 'Individual Professional - 1 Credit',
    description: 'For creating 1 professional headshot',
    price: 4900, // $49.00 in cents
    credits: 1,
    currency: 'usd',
    stripeProductId: 'prod_U0FibAtQGbHCks',
    stripePriceId: 'price_1T2FCbCb6qveZhLAXRlfQ1w8'
  },
  brandingKit: { // Renamed from 'teamPack'
    name: 'Personal Branding - 5 Credits',
    description: 'For creating 5 professional headshots',
    price: 20000, // $200.00 in cents
    credits: 5,
    currency: 'usd',
    stripeProductId: 'prod_U0Fl1L2b3twaei',
    stripePriceId: 'price_1T2FGPCb6qveZhLAH2oq0kRH'
  },
  
  // --- Team Plans ---
  teamPack: { // Renamed from 'smallTeam'
    name: 'Small Team Pack - 10 Credits',
    description: 'For creating 10 professional headshots',
    price: 38000, // $380.00 in cents
    credits: 10,
    currency: 'usd',
    stripeProductId: 'prod_U0Fn7aGuYtKZWd',
    stripePriceId: 'price_1T2FHsCb6qveZhLAgawPuKL5'
  },
  businessPack: { // Renamed from 'enterprise'
    name: 'Medium Team Pack - 50 Credits',
    description: 'For creating 50 professional headshots',
    price: 170000, // $1,700.00 in cents
    credits: 50,
    currency: 'usd',
    stripeProductId: 'prod_U0Fr3FYTtUzaJa',
    stripePriceId: 'price_1T2FLvCb6qveZhLAnywCEQqa'
  }
};

// Test card numbers for Stripe testing
export const TEST_CARDS = {
  successful: '4242424242424242',
  requiresAuthentication: '4000002500003155',
  declined: '4000000000000002',
  insufficientFunds: '4000000000009995'
};

// Export product configuration only